export const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'localhost:4000';
export const placeholderImageSrc =
'https://placehold.co/210x163/orange/white/png?text=Nh%C3%A0%20T%E1%BB%91t';

